//axios appi
import api from "@/lib/Api";

export const getAllCustomer = async () => {
  try {
    const queryRoute = `/customer/getAllCustomer/`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
